import { getJsonAsync } from "./fetchConfig";

export type Person = {
    firstName: string;
    lastName: string;
    nationality: { displayName: string }
}

export const getPerson = (personId: string) => getJsonAsync<Person>(`persons/${personId}`);
